<template>
  <!-- Floating version toggle shown on every page during an admin guest preview.
       z-145: above page content and the phone topbar (140), below the guest sidebar's
       drawer backdrop (149) and drawer (150) so it never covers the open menu. -->
  <div
    class="fixed bottom-4 left-1/2 -translate-x-1/2 z-[145] flex items-center gap-1 rounded-full border border-border bg-card/95 backdrop-blur px-1.5 py-1.5 shadow-lg text-xs"
    data-test="landing-version-switch"
  >
    <span class="px-2 font-semibold text-muted-foreground hidden sm:inline">Admin preview</span>
    <button
      v-for="v in versions"
      :key="v.value"
      type="button"
      class="rounded-full px-3 py-1 font-bold whitespace-nowrap transition-colors"
      :class="preference === v.value ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground'"
      :aria-pressed="preference === v.value"
      @click="setVersion(v.value)"
    >
      {{ v.label }}
    </button>
    <span class="w-px h-4 bg-border mx-0.5" aria-hidden="true"></span>
    <!-- Opening an admin page ends the preview (see router guard). -->
    <router-link
      to="/admin-dashboard/landing-page"
      class="rounded-full px-2.5 py-1 font-bold text-muted-foreground hover:text-foreground whitespace-nowrap"
      title="Exit preview"
      data-test="landing-preview-exit"
    >
      <i class="fas fa-xmark"></i><span class="hidden sm:inline ml-1">Exit</span>
    </router-link>
  </div>
</template>

<script>
import { useLandingVersion } from '@/composables/useLandingVersion';

export default {
  name: 'LandingVersionSwitch',
  setup() {
    const { preference, setVersion } = useLandingVersion();
    const versions = [
      { value: 'current', label: 'Current' },
      { value: 'v2', label: 'v2' },
      { value: 'olj', label: 'OLJ' },
      { value: 'olj2', label: 'OLJ 2' },
    ];
    return { preference, setVersion, versions };
  },
};
</script>
